import { tsoPqTheme } from '@assets/style/customTsoPqtheme';

const background = tsoPqTheme.palette.background;
const stroke = tsoPqTheme.palette.stroke;
const color = tsoPqTheme.palette.customTextColor;

export const buttonProps = {
  background: {
    filledPrimary: background.primary.color_primary_background_bg_prim_enabled,
    filledNeutral: background.neutral.color_neutral_background_bg_ntrl_enabled,
    filledPrimaryLight: background.primary.color_primary_background_bg_prim_enabled_lt,
    filledNeutralLight: background.neutral.color_neutral_background_bg_ntrl_enabled_lt,
    outlinedPrimary: background.other.color_other_background_white,
    outlinedNeutral: background.other.color_other_background_white,
    inputIconPrimary: 'transparent',
    inputIconNeutral: 'transparent',
    transparentPrimary: 'transparent',
    transparentNeutral: 'transparent',
    transparentPrimaryNoEffect: 'transparent',
    transparentNeutralNoEffect: 'transparent',
    disabledFilled: background.neutral.color_neutral_background_bg_ntrl,
    disabledOutline: background.other.color_other_background_white,
  },
  hover: {
    filledPrimary: background.primary.color_primary_background_bg_prim_hover,
    filledNeutral: background.neutral.color_neutral_background_bg_ntrl_hover,
    filledPrimaryLight: background.primary.color_primary_background_bg_prim_hover_lt,
    filledNeutralLight: background.neutral.color_neutral_background_bg_ntrl_hover_lt,
    outlinedPrimary: background.primary.color_primary_background_bg_prim_enabled_lt,
    outlinedNeutral: background.neutral.color_neutral_background_bg_ntrl_enabled_lt,
    inputIconPrimary: background.primary.color_primary_background_bg_prim_hover_lt,
    inputIconNeutral: background.neutral.color_neutral_background_bg_ntrl_hover_lt,
    transparentPrimary: background.primary.color_primary_background_bg_prim_enabled_lt,
    transparentNeutral: background.neutral.color_neutral_background_bg_ntrl_hover_lt,
    transparentPrimaryNoEffect: 'transparent',
    transparentNeutralNoEffect: 'transparent',
    disabledFilled: background.neutral.color_neutral_background_bg_ntrl,
    disabledOutline: background.other.color_other_background_white,
  },
  active: {
    filledPrimary: background.primary.color_primary_background_bg_prim_pressed,
    filledNeutral: background.neutral.color_neutral_background_bg_ntrl_pressed,
    filledPrimaryLight: background.primary.color_primary_background_bg_prim_pressed_lt,
    filledNeutralLight: background.neutral.color_neutral_background_bg_ntrl_pressed_lt,
    outlinedPrimary: background.primary.color_primary_background_bg_prim_hover_lt,
    outlinedNeutral: background.neutral.color_neutral_background_bg_ntrl_hover_lt,
    inputIconPrimary: background.primary.color_primary_background_bg_prim_pressed_lt,
    inputIconNeutral: background.neutral.color_neutral_background_bg_ntrl_pressed_lt,
    transparentPrimary: background.primary.color_primary_background_bg_prim_enabled_lt,
    transparentNeutral: background.neutral.color_neutral_background_bg_ntrl_pressed_lt,
    transparentPrimaryNoEffect: 'transparent',
    transparentNeutralNoEffect: 'transparent',
    disabledFilled: background.neutral.color_neutral_background_bg_ntrl,
    disabledOutline: background.other.color_other_background_white,
  },
  color: {
    filledPrimary: color.color_font_ft_white,
    filledNeutral: color.color_font_ft_white,
    filledPrimaryLight: color.color_neutral_font_ft_nrtrl_enabled,
    filledNeutralLight: color.color_neutral_font_ft_nrtrl_enabled,
    outlinedPrimary: color.color_primary_font_ft_prim_accent,
    outlinedNeutral: color.color_neutral_font_ft_nrtrl_enabled,
    inputIconPrimary: color.color_primary_font_ft_prim_accent,
    inputIconNeutral: color.color_neutral_font_ft_nrtrl_enabled,
    transparentPrimary: color.color_primary_font_ft_prim_accent,
    transparentNeutral: color.color_neutral_font_ft_nrtrl_enabled,
    transparentPrimaryNoEffect: color.color_primary_font_ft_prim_accent,
    transparentNeutralNoEffect: color.color_neutral_font_ft_nrtrl_enabled,
    disabledFilled: color.color_neutral_font_ft_nrtrl_enabled,
    disabledOutline: color.color_neutral_font_ft_nrtrl_enabled,
  },
  border: {
    filledPrimary: undefined,
    filledNeutral: undefined,
    filledPrimaryLight: undefined,
    filledNeutralLight: undefined,
    outlinedPrimary: {
      normal: stroke.color_primary_stroke_str_prim_enabled,
      hover: stroke.color_primary_stroke_str_prim_hover,
      active: stroke.color_primary_stroke_str_prim_pressed,
    },
    outlinedNeutral: {
      normal: stroke.color_neutral_stroke_str_ntrl_enabled,
      hover: stroke.color_neutral_stroke_str_ntrl_hover,
      active: stroke.color_neutral_stroke_str_ntrl_pressed,
    },
    inputIconPrimary: undefined,
    inputIconNeutral: undefined,
    transparentPrimary: undefined,
    transparentNeutral: undefined,
    transparentPrimaryNoEffect: undefined,
    transparentNeutralNoEffect: undefined,
    disabledFilled: undefined,
    disabledOutline: {
      normal: stroke.color_neutral_stroke_str_ntrl_disabled,
      hover: stroke.color_neutral_stroke_str_ntrl_disabled,
      active: stroke.color_neutral_stroke_str_ntrl_disabled,
    },
  },
  iconButton: {
    padding: {
      s: tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_iconbutton_sm_padding,
      m: tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding,
      l: tsoPqTheme.spacingValues.buttonSpacing.spacing_button_large_iconbutton_lg_padding,
    },
    iconSize: {
      xs: '0.75rem',
      s: '0.875rem',
      m: '1.125rem',
      l: '1.375rem',
    },
    size: {
      xs: '0.75rem',
      s: '1.875rem',
      m: '2.125rem',
      l: '2.625rem',
    },
  },
  classicButton: {
    iconSize: {
      xs: '0.75rem',
      s: '0.875rem',
      m: '1.125rem',
      l: '1.375rem',
    },
    size: {
      s: '1.875rem',
      m: '2.125rem',
      l: '2.625rem',
    },
    fontSize: {
      s: tsoPqTheme.typography.fontsize_button_button_small,
      m: tsoPqTheme.typography.fontsize_body_body_large,
      l: tsoPqTheme.typography.fontsize_button_button_medium,
    },
    padding: {
      xs: {
        noIcon: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l}`,
        iconLeft: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m}`,
        iconRight: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l}`,
      },
      s: {
        noIcon: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l}`,
        iconLeft: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m}`,
        iconRight: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_s} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_l}`,
      },
      m: {
        noIcon: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_l}`,
        iconLeft: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_l} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_m}`,
        iconRight: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_iconbutton_md_padding} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_l}`,
      },
      l: {
        noIcon: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_xl}`,
        iconLeft: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_xl} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_l}`,
        iconRight: `${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_l} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_small_button_sm_padding_m} ${tsoPqTheme.spacingValues.buttonSpacing.spacing_button_middle_button_md_padding_xl}`,
      },
    },
  },
};
